export default {
    "title": "Panel de Administración / Usuarios",
    "description": "Listado de usuarios actualmente dados de alta",
    "usersTableHeader": "Total: <0>{{count}}</0> | Activos: <0>{{countActive}}</0> | Inactivos: <0>{{countInactive}}</0> | Pendiente: <0>{{countPending}}</0>",
    "usersTableColumns": {
        "user_name": "Nombre y apellidos",
        "userType": "Tipo",
        "email": "Email",
        "date": "Fecha de alta",
        "client": "Cliente",
        "emailSent": "¿Email enviado?",
        "state": "Estado"
    },
    "popover": {
        "edit": "Editar",
        "activate": "Activar",
        "deactivate": "Desactivar",
        "email": "Enviar email",
        "delete": "Eliminar",
        "changePassword": "Cambiar contraseña"
    },
    "newUserDialog": {
        "title": "Crear usuario",
        "input": {
            "name": "Nombre *",
            "placeholder_name": "Nombre nuevo usuario",
            "surname": "Apellidos",
            "placeholder_surname": "Apellidos nuevo usuario",
            "email": "Email *",
            "placeholder_email": "Email nuevo usuario",
            "type": "Tipo *",
            "clients": "Cliente *",
            "cancel": "Cancelar"
        }
    },
    "editUserDialog": {
        "title": "Editar usuario",
        "text1": "Tipo de usuario:",
        "text2": "Cliente:",
        "input": {
            "name": "Nombre",
            "placeholder_name": "Editar nombre usuario",
            "surnames": "Apellidos",
            "placeholder_surname": "Editar apellidos",
            "email": "Email",
            "cancel": "Cancelar",
            "save": "Guardar"
        }
    },
    "deactivateUserDialog": {
        "title": "Desactivar usuario",
        "userType": "Tipo de usuario:",
        "client": "Cliente:",
        "text1": "Se va a desactivar el usuario, ¿estás seguro?",
        "text2": "El usuario no se podrá conectar ni realizar ninguna acción.",
        "deactivate": "Desactivar"
    },
    "activateUserDialog": {
        "title": "Activar usuario",
        "userType": "Tipo de usuario:",
        "client": "Cliente:",
        "text1": "Se va a activar el usuario, ¿estás seguro?",
        "text2": "El usuario podrá conectarse y realizar las acciones según su perfil y su visibilidad.",
        "activate": "Activar"
    },
    "deleteUserDialog": {
        "title": "Eliminar usuario",
        "userType": "Tipo de usuario:",
        "client": "Cliente:",
        "text1": "Se va a eliminar el usuario, ¿estás seguro?",
        "text2": "El usuario no aparecerá, y ya no se podrá concetar ni realizar ninguna acción en la aplicación.",
        "delete": "Eliminar"
    },
    "updatePasswordUserDialog": {
        "requirements": {
            "title": "Requisitos mínimos para la nueva contraseña:",
            "characters": "Al menos 6 caracteres",
            "lower": "Una letra minúscula",
            "upper": "Una letra mayúscula",
            "number": "Un dígito numérico",
            "special": "Un caracter especial"
        },
        "inputs": {
            "newPassword": "Nueva contraseña *",
            "verifyNewPassword": "Vuelve a introducir la contraseña *"
        },
        "validations": {
            "currentPassword": "La contraseña actual es obligatoria",
            "password": "No se cumplen todos los requisitos",
            "verifyPassword": "Las contraseñas no coinciden"
        },
    },
    "stateTag": {
        "active": "Activo",
        "inactive": "Inactivo",
        "pending": "Pendiente"
    },
    "sendEmail": "Enviar email al usuario",
    "funcWithAccess": {
        "label": "Funcionalidades con acceso",
        "invoices": "Facturas",
        "deliveryNotes": "Albaranes",
        "stock": "Existencias",
        "technicalsSheets": "Fichas técnicas",
        "activeOrders": "Pedidos activos",
        "showStats": "Mostrar estadísticas",
        "documentations": "Documentación",
        "chat": "Chat",
        "transportation": "Transportes",
    },
    "userType": {
        "admin": "Administrador",
        "client": "Cliente"
    },
    "userTypePlaceholder": "Tipo de usuario",
    "tooltip": {
        "newUserSendWelcomeEmail": "Si marcas esta opción se enviará un email de bienvenida al usuario en el momento de crearlo. Si decides no enviarle el email ahora, podrás enviárselo más adelante.",
        "updateUserSendEmail": "Si marcas esta opción se enviará un email al usuario en el momento de actualizarlo. Si decides no enviarle el email ahora, podrás enviárselo más adelante."
    },
    "toaster": {
        "success": {
            "createUser": "Usuario creado correctamente"
        }
    }
};